import { useI18n as baseUseI18n } from 'vue-i18n';
import type { Translations } from './i18n';

// ✨ Typed useI18n for all your autocomplete needs ✨
export const useI18n = () => baseUseI18n<{ message: Translations['en'] }, 'en'>();
